export function toNumber(value, fallback = 0) {
  const number = Number(value)
  return Number.isFinite(number) ? number : fallback
}

export function roundNumber(value, decimals = 2) {
  const factor = Math.pow(10, decimals)
  return Math.round((toNumber(value) + Number.EPSILON) * factor) / factor
}

export function addNumbers(values, decimals = 2) {
  return (Array.isArray(values) ? values : []).reduce(
    (total, value) => roundNumber(total + toNumber(value), decimals),
    0
  )
}

export function subtractNumbers(minuend, subtrahend, decimals = 2) {
  return roundNumber(toNumber(minuend) - toNumber(subtrahend), decimals)
}

export function formatNumber(value, decimals = 0) {
  return roundNumber(value, decimals).toLocaleString('zh-CN', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  })
}

export function percentValue(value, total, decimals = 1) {
  const denominator = toNumber(total)
  return denominator ? roundNumber((toNumber(value) / denominator) * 100, decimals) : 0
}

export function formatPercent(value, total, decimals = 1) {
  return `${formatNumber(percentValue(value, total, decimals), decimals)}%`
}

export function axisScale(value, splitNumber = 5) {
  const maximum = Math.max(toNumber(value), 0)
  if (!maximum) return { max: splitNumber, interval: 1 }
  const roughInterval = maximum / splitNumber
  const magnitude = Math.pow(10, Math.floor(Math.log10(roughInterval)))
  const normalized = roughInterval / magnitude
  const niceFactor = normalized <= 1 ? 1 : normalized <= 2 ? 2 : normalized <= 5 ? 5 : 10
  const interval = roundNumber(niceFactor * magnitude, 10)
  return {
    max: roundNumber(Math.ceil(maximum / interval) * interval, 10),
    interval
  }
}

export function dashboardTooltip(extra = {}) {
  return Object.assign({
    backgroundColor: 'rgba(3, 23, 40, .96)',
    borderColor: '#178ac5',
    borderWidth: 1,
    confine: true,
    padding: [8, 10],
    textStyle: { color: '#e5f2fb', fontSize: 12 }
  }, extra)
}
